import React, { FC } from 'react';
import { BulkNewProjectButtonProps } from './BulkNewProjectButtonProps';
import { Stack } from '@mui/material';
import chevronUp from '@ingka/ssr-icon/paths/chevron-up';
import chevronDown from '@ingka/ssr-icon/paths/chevron-down';
import ListView, { ListViewItem } from '@ingka/list-view';
import { establishmentTypes } from '../../containers/BulkCreate/utils';
import ListBox from '@ingka/list-box';
import Button from '@ingka/button';

const BulkNewProjectButton: FC<BulkNewProjectButtonProps> = ({
  onOptionClick,
  blue,
}) => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  return (
    <ListBox
      popupMode
      open={menuOpen}
      style={{ maxHeight: 'none' }}
      onMouseLeave={() => setMenuOpen(false)}
      trigger={
        blue ? (
          <Button
            type={'emphasised'}
            onClick={() => setMenuOpen(true)}
            ssrIcon={menuOpen ? chevronUp : chevronDown}
            iconPosition="trailing"
          >
            Create first project
          </Button>
        ) : (
          <Button
            type={'secondary'}
            size={'small'}
            onClick={() => setMenuOpen(true)}
            ssrIcon={menuOpen ? chevronUp : chevronDown}
            iconPosition="trailing"
          >
            Add new project
          </Button>
        )
      }
    >
      <ListView id="filter-menu" showDivider size="small">
        {establishmentTypes.map((item) => (
          <Stack sx={{ svg: { display: 'none' } }}>
            <ListViewItem
              control={'navigational'}
              inset
              title={item.label}
              onClick={() => {
                onOptionClick(item.value);
                setMenuOpen(false);
              }}
              id={`filter-item-${item.value}`}
            />
          </Stack>
        ))}
      </ListView>
    </ListBox>
  );
};

export default BulkNewProjectButton;
